import { z } from "zod";
export const applicationStatusEnum = z.enum([
    "PENDING_AUDIT",
    "NEW",
    "UNDER_REVIEW",
    "APPROVED",
    "REJECTED",
    "AUDIT_BLOCKED",
]);
/**
 * U-3 応募フォーム
 */
export const applicationSchema = z.object({
    organizationName: z
        .string()
        .min(1, "所属組織名を入力してください")
        .max(120, "所属組織名は120文字以内で入力してください"),
    department: z
        .string()
        .min(1, "部署を入力してください")
        .max(100, "部署は100文字以内で入力してください"),
    role: z
        .string()
        .min(1, "役割を入力してください")
        .max(100, "役割は100文字以内で入力してください"),
    contactName: z
        .string()
        .min(1, "担当者名を入力してください")
        .max(60, "担当者名は60文字以内で入力してください"),
    contactEmail: z.string().email("有効なメールアドレスを入力してください"),
    proposalSummary: z
        .string()
        .min(1, "提案概要を入力してください")
        .max(2000, "2000文字以内で入力してください"),
    message: z.string().max(2000).optional(),
});
/**
 * 応募ステータス変更
 */
export const updateApplicationStatusSchema = z.object({
    status: applicationStatusEnum,
});
export const applicationListQuerySchema = z.object({
    // q は 4 つの leading-wildcard ILIKE に渡るため、長さを上限で抑える（use-case 側と同じ 200）。
    q: z.string().max(200).optional(),
    status: applicationStatusEnum.optional(),
    statuses: z.string().max(200).optional(),
    /** 受入企業名（案件投稿企業）の絞り込み。カンマ区切り。 */
    organizationNames: z.string().max(2000).optional(),
    /** 案件の関連技術の絞り込み。カンマ区切り。 */
    technologies: z.string().max(1000).optional(),
    /** 案件の業界の絞り込み。カンマ区切り。 */
    industries: z.string().max(500).optional(),
    // 深いオフセットによるコストアンプを避けるため page に上限を設ける。
    page: z.coerce.number().int().min(1).max(10_000).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
